import React, {
  CSSProperties,
  FC,
  SyntheticEvent,
  useCallback,
  useContext,
} from 'react'

import { cx } from '@linaria/core'
import { Link } from 'react-router-dom'

import { CloseSvg } from 'components/designSystem/svgr/CloseSvg'
import { Direction } from 'components/page/RatingWave/Rating.types'
import { useAuthorizationPath } from 'hooks/useAuthorizationLink'
import { useAuthorized } from 'hooks/useAuthorized'

import { commonCss } from './buttons.styled'
import { iconProps } from './constants'
import { ControlButtonContext } from '../context/ControlButtonContext'

export const Dislike: FC<{ style: CSSProperties }> = ({ style }) => {
  const authorized = useAuthorized()
  const authorizationPath = useAuthorizationPath()
  const { onHandleClick } = useContext(ControlButtonContext)

  const handleClick = useCallback(
    (event: SyntheticEvent) => {
      if (authorized) {
        event.preventDefault()
        onHandleClick(Direction.left)
      }
    },
    [authorized, onHandleClick]
  )

  return (
    <Link
      to={authorizationPath}
      style={style}
      className={cx(commonCss)}
      onClick={handleClick}
      data-name="dislike-action"
    >
      <CloseSvg {...iconProps} innerFill="currentColor" />
    </Link>
  )
}
